import { AxiosResponse } from 'axios';
import { DataWizardAct, SignatureActUscVM } from 'civil-status/view-models/step-form';
import { DateTime } from 'luxon';
import { HttpResponse } from 'shell/models/http-response';

export const transformerActSignatureUsc = (
  response: AxiosResponse<HttpResponse<DataWizardAct>>,
  otp?: string
): SignatureActUscVM => {
  const castedResponseEvento = response.data?.payload?.evento || {};
  const castedResponseStatoCivile = response.data?.payload?.statoCivile || {};
  const castedResponseOperatoreUsc = response.data?.payload?.operatoreUsc || {};

  return {
    idAnsc: castedResponseEvento.idAnsc || '',
    idState: castedResponseEvento.codiceStatoEvento || '',
    dateValidity: DateTime.now(),
    isAnagrafica: true,
    otp: otp || '',
    pin: '',
    user: castedResponseOperatoreUsc.codiceFirma || '',
    operatorName: castedResponseEvento.operatoreNome || '',
    operatorSurname: castedResponseEvento.operatoreCognome || '',
    idEventoCorrelato: castedResponseStatoCivile.idEventoCorrelato?.toString(),
  };
};
